<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="orders.data"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
                v-on:update:pagination="ordenar"
        >
            <template slot="items" slot-scope="props">
                <tr>
                    <td @click="ver(props.item.id)">{{ props.item.our_order_number }}</td>
                    <td @click="ver(props.item.id)" class="text-xs" >{{ props.item.client_name }}</td>
                    <td @click="ver(props.item.id)" class="text-xs">{{ props.item.status.name }}</td>
                    <td @click="ver(props.item.id)" class="text-xs">{{ props.item.date }}</td>
                </tr>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-1 pb-1" v-if="orders.data">
            <v-pagination
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ orders.meta.from }} to {{ orders.meta.to }} of {{ orders.meta.total }} entries</p>
        </div>
    </div>
</template>

<script>
    import { BASE } from '../../../../config';

    export default {
        data () {
            return {
                page: null,
                last_page: null,
                pagination: {sortBy: 'date', descending: true},
                loading: true,
                headers: [
                    {
                        text: 'Number order',
                        align: 'left',
                        sortable: true,
                        value: 'our_order_number'
                    },
                    { text: 'Client', value: 'cliente_id', sortable: true },
                    { text: 'Status', value: 'status_id', sortable: true },
                    { text: 'Date', value: 'date', sortable: true }
                ],
                orders: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                BASE: BASE,
                download_token: null,
                sortBy: 'date',
                order: 'asc',
            }
        },
        created: function() {
            this.getOrders();
            this.checkUser();
        },
        watch: {
            last_page: function () {
                if (this.page > this.orders.meta.last_page) {
                    this.page = 1;
                }
            },
        },
        methods : {
            ordenar(payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getOrders();
            },
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            setPage (page) {
                this.page = page;
                this.getOrders();
            },
            getOrders () {
                var params = {
                    filters : {
                        search: '',
                        page: this.page,
                        client_id: 'null',
                        status_id: 1,
                        sortBy: this.sortBy,
                        order: this.order,
                        per_page: 4
                    }
                };
                this.$store.dispatch('getOrders', params).then((res) => {

                    this.orders = res.data;
                    this.loading = false;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            ver(id) {
                let route = this.$router.resolve({ name: 'admin.orders.detail', params : { id : id } });
                window.open(route.href, '_blank');
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/home/Components/OrdersTable.vue